import { AxiosInstance } from "axios";
import { BaseApiModule } from "./base.module";
import { unstrapiMany, unstrapiOne } from "../../helpers/strapi";
import { ClinicType } from "../../types/appointment-types";
import { FindManyParams } from "../types";

export class ClinicsApiModule extends BaseApiModule {
  constructor(client: AxiosInstance) {
    super(client, "api");
  }

  async fetchClinics() {
    return this.client
      .get(`api/clinics`, {
        params: {
          populate: ["state"]
        }
      })
      .then((res) => {

        console.debug(`clinics - ${JSON.stringify(res.data)}`)
        return unstrapiMany<ClinicType>(
          res.data,
          "clinic"
        )
      }
      );
  }

  // find(id: number, populate: string[] = []) {

  //   const _populate = populate?.length > 0 ? populate : ["user", "user.state", "user.profilePicture", "states", "serviceTypes", "service_provider_types", "languages"];
  //   ////console.debug('populate ' + _populate)
  //   if (!id)
  //     return

  //   return this.client
  //     .get(`api/service-providers/${id}`, {
  //       params: {
  //         populate: _populate
  //       }
  //     })
  //     .then((res) =>
  //       unstrapiOne<ServiceProviderType>(res.data, "serviceProvider")
  //     );
  // }

  // findMany(params: FindManyParams = {}, returnMeta: boolean = false) {
  //   //console.debug (`params - ${JSON.stringify(params)}`)
  //   return this.client
  //     .get(`api/service-providers`, { params })
  //     .then((res) =>
  //       unstrapiMany<ServiceProviderType>(
  //         res.data,
  //         "serviceProvider",
  //         returnMeta
  //       )
  //     );
  // }

  // update(id: number, data: Partial<ServiceProviderType>) {
  //   ////console.debug('updating service provider profile - ' + JSON.stringify(data))
  //   return this.client
  //     .put(`api/service-providers/${id}`, { data })
  //     .then((res) =>
  //       unstrapiOne<ServiceProviderType>(res.data, "serviceProvider")
  //     );
  // }

  // findAvailable(memberService: number) {
  //   return this.client
  //     .get(`api/service-providers/available`, {
  //       params: {
  //         memberService
  //       }
  //     })
  //     .then((res) =>
  //       unstrapiMany<ServiceProviderType>(res.data, "serviceProvider")
  //     );
  // }
}
